import { Delete } from '@mui/icons-material';
import React, { useState, useEffect } from 'react';
import {
  Modal,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Input,
  Label,
} from 'reactstrap';

const EditQuizModal = ({
  isTeacher,
  isOpen,
  toggleModal,
  updateQuiz,
  quizToEdit,
}) => {
  const [quizData, setQuizData] = useState({
    id: '',
    name: '',
    numberOfQuation: 0,
    price: 0, // Added price field
    status: 0,
    createdAt: '',
    subjectWeightage: [{ subject: '', percentage: 0 }]
  });

  useEffect(() => {
    if (quizToEdit) {
      console.log(quizToEdit, "quizToEdit1");
      setQuizData({
        ...quizToEdit,
        price: quizToEdit.price || 0, // Populate price from quizToEdit
        subjectWeightage: quizToEdit.subjectWeightage || [
          { subject: '', percentage: 0 },
        ],
      });
    }
  }, [quizToEdit]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setQuizData({
      ...quizData,
      [name]:
        name === 'numberOfQuation' || name === 'price' ? Number(value) : value,
    });
  };


  const handleSubmit = (e) => {
    e.preventDefault();

    try {
      const { name, price
        // , quizTime 
      } = quizData;

      // Ensure required fields are not empty
      if (!name.trim() || (!price && price !== 0)
      //  || !quizTime
      ) {
        alert("Please fill in all required fields.");
        return;
      }

      // Convert quizTime to an integer
      // const updatedQuiz = {
      //   ...quizData,
      //   quizTime: parseInt(quizTime, 10), // Ensure it's stored as an integer
      // };
      // Call the update function
      updateQuiz(quizData);
      toggleModal();
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      alert("Something went wrong. Please try again.");
    }
  };


  const inputStyle = {
    backgroundColor: '#2c2f47',
    color: '#fff',
    border: '1px solid #5a5e75',
  };

  return (
    <Modal isOpen={isOpen} toggle={toggleModal} size='lg'>
      <div
        style={{
          backgroundColor: 'rgb(39, 41, 61)',
          padding: '10px 15px',
          color: '#fff',
          fontSize: '18px',
          fontWeight: 'bold',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        Edit Mock
        <button
          type='button'
          className='close'
          onClick={toggleModal}
          style={{
            color: '#fff',
            fontSize: '24px',
            border: 'none',
            background: 'none',
            cursor: 'pointer',
          }}
        >
          &times;
        </button>
      </div>

      <ModalBody
        style={{
          backgroundColor: 'rgb(39, 41, 61)',
          padding: '20px 20px 0 20px'
          
        }}
      >
        <form onSubmit={handleSubmit}>
          <FormGroup>
            <Label style={{ color: '#fff' }}>Mock Name*</Label>
            <Input
              type='text'
              name='name'
              value={quizData.name}
              onChange={handleInputChange}
              placeholder='Enter quiz name'
              style={inputStyle}
              required
            />
          </FormGroup>

          {/* <FormGroup>
                        <Label style={{ color: '#fff' }}>Number of Questions</Label>
                        <Input
                            type="number"
                            name="numberOfQuation"
                            value={quizData.numberOfQuation}
                            onChange={handleInputChange}
                            placeholder="Enter number of questions"
                            style={inputStyle}
                            required
                        />
                    </FormGroup> */}

          <FormGroup>
            <Label style={{ color: '#fff' }}>Price*</Label>
            <Input
              disabled={isTeacher?true:false}
              type='number'
              name='price'
              value={quizData.price}
              onChange={handleInputChange}
              placeholder='Enter price'
              style={inputStyle}
              required
            />
          </FormGroup>

          {/* <FormGroup>
            <Label style={{ color: '#fff' }}>Mock Time (in Minutes)</Label>
            <Input
              type='number'
              name='time'
              value={quizData.quizTime}
              onChange={(e) => {
                console.log(e?.target?.value);
                setQuizData({ ...quizData, quizTime: e?.target?.value });
              }}
              placeholder='Enter quiz time'
              style={inputStyle}
              required
            />
          </FormGroup> */}

          {/* <div>
                        <Label style={{ color: '#fff' }}>Subject Weightage</Label>
                        {quizData.subjectWeightage.map((item, index) => (
                            <div
                                key={index}
                                style={{
                                    display: 'grid',
                                    gridTemplateColumns: '1fr 1fr auto',
                                    gap: '10px',
                                    borderRadius: '7px',
                                    marginBottom: '15px',
                                }}
                            >
                                <Input
                                    type="select"
                                    name="subject"
                                    value={item.subject}
                                    onChange={(e) => handleSubjectWeightageChange(e, index)}
                                    style={{ ...inputStyle, borderRadius: '7px' }}
                                    required
                                >
                                    <option value="">Select a Subject</option>
                                    {fetchSubject.map((subject, idx) => (
                                        <option key={idx} value={subject.name}>
                                            {subject.name}
                                        </option>
                                    ))}
                                </Input>

                                <Input
                                    type="number"
                                    name="percentage"
                                    value={item.percentage}
                                    placeholder="Enter percentage"
                                    onChange={(e) => handleSubjectWeightageChange(e, index)}
                                    style={inputStyle}
                                    required
                                />
                                <Delete
                                    color="danger"
                                    onClick={() => removeSubject(index)}
                                    style={{ color: 'red', cursor: 'pointer', marginTop: '7px' }}
                                />
                            </div>
                        ))}
                        <Button color="info" onClick={addNewSubject} style={{ marginBottom: '10px' }}>
                            Add Subject
                        </Button>
                    </div> */}
        </form>
      </ModalBody>

      <ModalFooter
        style={{
          backgroundColor: 'rgb(39, 41, 61)',
          display: 'flex',
          justifyContent: 'end',
          paddingTop: '10px',
          gap: '8px',
        }}
      >
        <Button color='secondary' onClick={toggleModal}>
          Cancel
        </Button>
        <Button color='info' onClick={handleSubmit}>
          Save Changes
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default EditQuizModal;
